import { BaseError } from "./BaseError";
import type { ErrorContext } from "../types/index";
import { VALIDATION_ERROR_CODES } from "../constants/errorCodes";

export interface ValidationErrorOptions {
  message: string;
  field?: string;
  value?: unknown;
  context?: Partial<ErrorContext>;
  code?: string;
  cause?: Error;
}

/**
 * Error thrown when validation fails
 */
export class ValidationError extends BaseError {
  public readonly field?: string;
  public readonly value?: unknown;

  constructor(options: ValidationErrorOptions) {
    super({
      message: options.message,
      category: "validation",
      severity: "medium",
      statusCode: 400,
      code: options.code ?? VALIDATION_ERROR_CODES.VALIDATION_ERROR,
      context: options.context,
      cause: options.cause,
      userVisible: true,
      reportable: false,
    });

    this.field = options.field;
    this.value = options.value;
  }
}
